module.exports = __webpack_public_path__ + "static/img/pic_pdf_vip@2x.f7023813.png";